// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wq-0";
export var confirmationIcon = "_wq-1";